import type { MediaModel, IMediaTableFilters, MediaPaginatorResponse } from 'src/types/media';

import useSWR from 'swr';

import { getMedia, getMedias } from 'src/api/media.api';

export function useMedias(page: number, limit: number, filters: IMediaTableFilters) {
  const key = [
    '/medias',
    page,
    limit,
    filters.mediaId,
    filters.name,
    filters.url,
    filters.searchTerm,
    filters.email,
    filters.linkType,
    filters.mediaType,
    filters.categories,
    filters.country, // Ya es array, mantenemos como está
    filters.language,
    filters.redactionField,
    filters.active,
    filters.drMin,
    filters.drMax,
    filters.daMin,
    filters.daMax,
    filters.tfMin,
    filters.tfMax,
    filters.trafficMin,
    filters.trafficMax,
    filters.priceMin,
    filters.priceMax,
    filters.orderBy,
    filters.orderDirection,
    filters.editorStatus,
  ];

  const { data, error, isLoading, mutate } = useSWR<MediaPaginatorResponse>(
    key,
    () => getMedias({ page, pageSize: limit, ...filters }) as Promise<MediaPaginatorResponse>,
    { revalidateOnFocus: false, revalidateOnReconnect: false }
  );

  return {
    medias: data,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useMedia(id: string) {
  const key = ['/media', id];

  const { data, error, isLoading } = useSWR<MediaModel>(key, () => getMedia(Number(id)), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    media: data,
    isLoading,
    isError: error,
  };
}
